import React, { ReactElement } from "react";
import useShowMoreCounter from "~/lib/hooks/useShowMoreCounter";
import * as palette from "@govlaunch/palette";
import { IGovernment, IStory } from "~/types/types";
import StoryListItemDividers from "~/components/story/StoryListItemDividers";
import StoryListItemHoverContainer from "~/components/story/StoryListItemHoverContainer";
import StoryListItem, { TStoryListItemStory } from "~/components/story/StoryListItem";
import { FormattedMessage, useIntl } from "react-intl";

interface IStoriesProps {
  government: Pick<IGovernment, "_id" | "viewerIsMember">;
  stories: IStory[];
}

interface IShowMoreProps {
  onClick: () => any;
}

export default function GovernmentStories({ stories }: IStoriesProps): ReactElement {
  const { offset, showMore, hasMore } = useShowMoreCounter(stories.length, 4);

  return (
    <div
      css={{
        backgroundColor: palette.white,
        borderRadius: 5,
        border: `solid 1px ${palette.lightestGray}`,
      }}
      data-intercom-target="Government Stories"
    >
      <StoryListItemDividers>
        {stories.slice(0, offset).map(story => {
          return (
            <StoryListItemHoverContainer
              key={story._id}
              style={{
                padding: 15,
              }}
            >
              <StoryListItem story={story as TStoryListItemStory} />
            </StoryListItemHoverContainer>
          );
        })}
      </StoryListItemDividers>

      {hasMore && <ShowMore onClick={showMore} />}
    </div>
  );
}

const ShowMore: React.FunctionComponent<IShowMoreProps> = props => {
  const intl = useIntl();

  return (
    <div
      role="button"
      aria-label={intl.formatMessage({
        defaultMessage: 'View More', id: 'QQSdHP',
      })}
      css={{
        padding: 15,
        textTransform: "uppercase",
        color: palette.sealBlue,
        fontSize: 12,
        textAlign: "center",
        fontWeight: 500,
        cursor: "pointer",
        borderTop: `solid 1px ${palette.lightestGray}`,
        "&:hover": {
          color: palette.darkGray,
        },
      }}
      {...props}
    >
      <FormattedMessage defaultMessage="View More" id="QQSdHP" />
    </div>
  );
};
